export default {
    getCurrentUser: (state) => state.currentUser,
    getPassedUser: (state) => state.passedUser
}
